<div class="font-noto trans-x-hide tw-h-full" swipe="swipe" (coordinates)="swipeCoordinates($event)" [ngClass]="{'trans-xy-0': isTabActive }">
  <div class="tw-flex flex-col tw-bg-white tw-h-full" #homePageContainer="">
    <!--nav bar-->
    <div class="tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-z-10 tw-flex tw-flex-row tw-items-center tw-gap-2 tw-bg-transparent tw-px-4 tw-py-4">
      <div class="tw-flex-none tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-rounded-xl tw-h-10 tw-w-10 cs-icon-menu" (click)="toggleMenu(true)">
        <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'menu'"></cs-icon>
      </div>
      <div class="tw-flex-1"></div>
      @if (showCashBalance) {
        <div class="tw-flex-none tw-flex tw-items-center tw-justify-center tw-gap-2 tw-px-4 tw-rounded-full tw-h-10 tw-border-2 tw-border-white tw-bg-teal-200" (click)="openBottomSheetForCash()">
          <cs-icon class="tw-h-6 tw-w-6" [iconName]="'cureskin_cash_coin'"></cs-icon>
          <p class="tw-font-body tw-font-bold tw-text-400 tw-pt-[2px]">
            {{totalCashBalance}}
          </p>
        </div>
      }
      @if ((toolbarIcons[1].cartValue && userStatus.PAID) || showAcqShopProductsBanner) {
        <div id="home-cart-icon" class="tw-flex-none tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-rounded-xl tw-h-10 tw-w-10 tw-relative" (click)="goToCart()">
          <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'shopping_cart'"></cs-icon>
          <span class="tw-absolute tw-top-[2px] tw-right-[18%] tw-bg-gray-800 tw-font-body tw-font-bold tw-h-[14px] tw-text-200 tw-text-red-400">{{toolbarIcons[1]?.cartValue}}</span>
        </div>
      }
      <div class="tw-flex-none tw-relative tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-rounded-xl tw-h-10 tw-w-10" (click)="notificationClickAction()" [ngClass]='unreadNotifications ? "notify-icon-new" : ""'>
        <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'notifications'"></cs-icon>
      </div>
    </div>
    <!--loading-->
    @if (loading) {
      <div class="shell tw-flex-1 tw-pt-14">
        <div class="welcome">
          <div class="title shimmer"></div>
          <div class="desc shimmer"></div>
        </div>
        <section class="three">
          <div class="cardHolder">
            @for (i of [1,2,3]; track i) {
              <div class="card shimmer"></div>
            }
          </div>
        </section>
        @for (i of [1,2]; track i) {
          <section>
            <div class="header">
              <div class="title shimmer"></div>
              <div class="desc shimmer"></div>
            </div>
            <div class="cardHolder">
              <div class="card shimmer"></div>
              <div class="card shimmer"></div>
            </div>
          </section>
        }
      </div>
    }
    @if (!loading) {
      <div class="tw-flex tw-flex-col content tw-flex-1 tw-bg-gray-80 tw-overflow-y-auto tw-overflow-x-hidden [&>app-banner-wrapper:last-child]:tw-mb-0" [ngClass]="{
        'tw-pb-44': isDiscomfortBannerActive,
        'tw-pb-50': isDiscomfortVoiceNoteBannerActive,
        'tw-pb-28': !(isDiscomfortBannerActive && isDiscomfortVoiceNoteBannerActive)}">
        <div class="tw-flex tw-flex-col tw-bg-teal-200 tw-bg-repeat-x tw-bg-top tw-pt-14 tw-px-0 tw-overflow-visible tw-mb-17 tw-pb-0">
          <!--Three icons in header(Unpaid state)-->
          <div class="tw-mt-12 three-icons tw-px-4 tw-relative tw-left-0 tw-right-0 tw-mb-[-56px]">
            @if (!userStatus.PAID) {
              <div appTrackable bannerName="top_navigation_unpaid" pageName="homePage" class="tw-grid tw-grid-cols-2 tw-gap-2">
              <div class="fading-grid-pattern tw-bg-gray-50 tw-px-4 tw-py-2 tw-rounded-[15px] tw-flex-1" (click)="trackEventAndNavigateTo('HOME_FACE', '/user?tab=regimen&amp;class=FACE')">
                <img class="tw-max-h-[56px]" [src]="faceIconUrl" />
                <div class="tw-flex tw-justify-between tw-items-center tw-gap-2 fw-500 font14 tw-mt-2">
                  <span class="text face tw-text-300 tw-text-gray-800" i18n="@@faceTreatment">Face Treatment</span>
                  <em class="cs-icon-arrow font10 fw-700 tw-text-gray-800"></em>
                </div>
              </div>
              <div class="fading-grid-pattern tw-bg-gray-50 tw-px-4 tw-py-2 tw-rounded-[15px] tw-flex-1" (click)="trackEventAndNavigateTo('HOME_HAIR', '/user?tab=regimen&amp;class=HAIR')">
                <img class="tw-max-h-[56px]" [src]="hairIconUrl" />
                <div class="tw-flex tw-justify-between tw-items-center tw-gap-2 fw-500 font14 tw-mt-2">
                  <span class="text hair tw-text-300 tw-text-gray-800" i18n="@@hairTreatment">Hair Treatment</span>
                  <em class="cs-icon-arrow font10 fw-700 tw-text-gray-800"></em>
                </div>
              </div>
            </div>
            }
            @if (userStatus.PAID && !isRebrandingHomeIcon) {
              <div appTrackable bannerName="top_navigation_paid" pageName="homePage" class="tw-flex tw-flex-row tw-gap-2">
              <div class="tw-flex-1 card tw-px-3 tw-pt-2 tw-pb-3 tw-rounded-2xl" [ngClass]="{'tw-break-all': [appConfig.Shared.Languages.ML, appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference'))}" (click)="trackEventAndNavigateTo('HOME_INSTRUCTIONS', '/user?tab=regimen&fromHowToUse=true')">
                <div class="tw-relative tw-inline-flex">
                  <img class="rounded mB10 flex-col tw-items-center" src="https://cdn.cureskin.com/app/img/home_how_to_use.png" />
                  @if (hasRecentlyDeliveredRegimen) {
                    <span class="tw-absolute tw-top-0 tw-right-0 tw-h-2 tw-w-2 tw-rounded-full tw-bg-red-300"></span>
                  }
                </div>
                <div class="tw-font-body tw-font-bold tw-text-black tw-text-200 tw-text-center tw-tracking-0 tw-leading-none" i18n="@@howToUse"> How to use </div>
              </div>
              <div class="tw-flex-1 card tw-px-3 tw-pt-2 tw-pb-3 tw-rounded-2xl" [ngClass]="{'tw-break-all': [appConfig.Shared.Languages.ML, appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference')), 'notify notify-new': tabUpdates.FOLLOWUP}" (click)="trackEventAndNavigateTo('HOME_NEED_CHECKUP', '/user/checkup')">
                <img class="rounded mB10" src="https://cdn.cureskin.com/app/img/home_checkup.png" />
                <div class="tw-font-body tw-font-bold tw-text-black tw-text-200 tw-text-center tw-tracking-0 tw-leading-none" i18n="@@doctorCheckup"> Doctor Checkup </div>
              </div>
              <div class="tw-flex-1 card tw-px-3 tw-pt-2 tw-pb-3 tw-rounded-2xl" [ngClass]="{'tw-break-all': [appConfig.Shared.Languages.ML, appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference')), 'notify notify-new': tabUpdates.FOLLOWUP}" (click)="trackEventAndNavigateTo('HOWE_SHOP', '/user?tab=shop')">
                <img class="rounded mB10" src="https://cdn.cureskin.com/app/img/home_shop.gif" />
                <div class="tw-font-body tw-font-bold tw-text-black tw-text-200 tw-text-center tw-tracking-0 tw-leading-none" i18n="@@shopProducts"> Shop products </div>
              </div>
              <div class="tw-flex-1 card tw-px-3 tw-pt-2 tw-pb-3 tw-rounded-2xl" [ngClass]="{'tw-break-all': [appConfig.Shared.Languages.ML, appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference')), 'notify notify-new': tabUpdates.FOLLOWUP}" (click)="trackEventAndNavigateTo('HOME_NEED_HELP', '/support')">
                <img class="rounded mB10" src="https://cdn.cureskin.com/app/img/home_need_help.png" />
                <div class="tw-font-body tw-font-bold tw-text-black tw-text-200 tw-text-center tw-tracking-0 tw-leading-none" i18n="@@needHelp">Need help</div>
              </div>
            </div>
            }
            @if (userStatus.PAID && isRebrandingHomeIcon) {
              <div appTrackable bannerName="top_navigation_paid" pageName="homePage" class="tw-flex tw-flex-row tw-justify-center tw-items-stretch tw-gap-2">
              <div class="tw-flex-grow tw-h-[104px] tw-w-[76px] tw-flex tw-flex-col tw-items-center tw-px-[10px] tw-pt-2 tw-pb-3 tw-rounded-2xl card"
                   [ngClass]="{'tw-break-all tw-text-[6px]': enableNgClassCondition() }"
                   (click)="trackEventAndNavigateTo('HOME_INSTRUCTIONS', '/user?tab=regimen&fromHowToUse=true')">
                <div class="tw-relative tw-inline-flex tw-mb-2">
                  <cs-icon class="tw-h-[52px] tw-w-[52px]" [iconName]="'home_how_to_use'"></cs-icon>
                  @if (hasRecentlyDeliveredRegimen) {
                    <img src="/assets/gifs/blinking-red-dot.gif" class="tw-absolute tw-top-1 tw-right-1 tw-w-[10px]" alt="red-blink-circle"/>
                  }
                </div>
                @if (isRegimenExpired) {
                  <div class="tw-font-body tw-font-medium tw-text-black tw-text-200 tw-text-center tw-tracking-0 tw-leading-none" [ngClass]="{'tw-break-all tw-text-[10px]': enableNgClassCondition() }" i18n="@@getRegimen">
                    Get Regimen
                  </div>
                } @else {
                  <div class="tw-font-body tw-font-medium tw-text-black tw-text-200 tw-text-center tw-tracking-0 tw-leading-none" i18n="@@howToUse"
                     [ngClass]="{'tw-break-all tw-text-[10px]': enableNgClassCondition() }"
                >
                  How to use
                </div>
                }
              </div>
              <div class="tw-flex-grow tw-h-[104px] tw-w-[76px] tw-flex tw-flex-col tw-items-center tw-px-[10px] tw-pt-2 tw-pb-3 tw-rounded-2xl card"
                [ngClass]="{'tw-break-all tw-text-[12px]': enableNgClassCondition(), 'notify notify-new': tabUpdates?.FOLLOWUP}"
                (click)="trackEventAndNavigateTo('HOME_NEED_CHECKUP', '/user/checkup')">
                <div class="tw-h-[52px] tw-w-[52px] tw-rounded-full tw-relative tw-mb-2">
                  <cs-icon class="tw-h-[52px] tw-w-[52px] tw-relative" [iconName]="'home_doctor_checkup'"></cs-icon>
                  @if (shouldShowFollowUpDot) {
                    <img src="/assets/gifs/blinking-red-dot.gif" class="tw-absolute tw-top-1 tw-right-1 tw-w-[10px]" alt="red-blink-circle"/>
                  }
                </div>
                <div class="tw-font-body tw-font-medium tw-text-black tw-text-200 tw-text-center tw-tracking-0 tw-leading-none" i18n="@@doctorCheckup"> Doctor Checkup </div>
              </div>
              <div class="tw-flex-grow tw-h-[104px] tw-w-[76px] tw-flex tw-flex-col tw-items-center tw-px-[10px] tw-pt-2 tw-pb-3 tw-rounded-2xl card"
                   [ngClass]="{'tw-break-all tw-text-[12px]': enableNgClassCondition(), 'notify notify-new': tabUpdates?.FOLLOWUP}" (click)="trackEventAndNavigateTo('HOWE_SHOP', '/user?tab=shop')">
                <img class="tw-mb-2 tw-h-[52px] tw-w-[52px]" src="/assets/icons/home_shop.gif" />
                <div class="tw-font-body tw-font-medium tw-text-black tw-text-200 tw-text-center tw-tracking-0 tw-leading-none" i18n="@@shopProducts"> Shop products </div>
              </div>
              <div class="tw-flex-grow tw-h-[104px] tw-w-[76px] tw-flex tw-flex-col tw-items-center tw-px-[10px] tw-pt-2 tw-pb-3 tw-rounded-2xl card relative"
                  [ngClass]="{'tw-break-all tw-text-[12px]': enableNgClassCondition(), 'notify notify-new': tabUpdates?.FOLLOWUP}" (click)="trackEventAndNavigateTo('HOME_NEED_HELP', '/support')">
                <div class="tw-relative">
                  @if (isTicketAwaitingResponse) {
                    <img src="/assets/gifs/blinking-red-dot.gif" alt="red-blink-circle" class="tw-w-[10px] tw-h-[10px] tw-aspect-square tw-absolute tw-top-2 tw-right-1 -tw-translate-y-1/3 tw-translate-x-1/3" />
                  }
                  <cs-icon class="tw-mb-2 tw-h-[52px] tw-w-[52px]" [iconName]="'home_help'"></cs-icon>
                </div>
                <div class="tw-font-body tw-font-medium tw-text-black tw-text-200 tw-text-center tw-tracking-0 tw-leading-none" i18n="@@needHelp">Need help</div>
              </div>
            </div>
            }
          </div>
        </div>

        @if (languageBannerContent(); as banner) {
          <app-banner-wrapper [width]="BannerWidth.Inset">
            <app-language-banner appTrackable pageName="homePage" bannerName="language_banner"
              [content]="banner"></app-language-banner>
          </app-banner-wrapper>
        }

        @if (shouldShowGamificationRewardBanner && rewardData) {
          <app-banner-wrapper appTrackScrollDepth="gamification_reward">
            <app-gamification-reward-banner [rewardData]="rewardData" [isClaimed]="isRewardClaimed()" (openScratchCard)="onOpenScratchCard()"></app-gamification-reward-banner>
          </app-banner-wrapper>
        }

        @if (showScratchCard && rewardData) {
          <app-gamification-scratch-card
            [rewardData]="rewardData"
            [show]="showScratchCard"
            (closed)="onScratchCardClosed()"
            (rewardClaimed)="onRewardClaimed($event)">
          </app-gamification-scratch-card>
        }

        @if (isotretinoinConsentPendingOrder) {
          <app-banner-wrapper appTrackScrollDepth="isotretinoin_consent_pending">
            <app-isotretinoin-consent-pending
              [orderId]="isotretinoinConsentPendingOrder.id"
              [pregnancyAnswered]="isotretinoinPregnancyAnswered">
            </app-isotretinoin-consent-pending>
          </app-banner-wrapper>
        }

        <app-swiper-wrapper appTrackScrollDepth="regimen_preparation" paginationId="regimen-preparation-pagination">
          <swiper #swiperCardsBanner="" class="tw-max-w-full tw-overflow-visible" [config]="regimenPreparationCarouselConfig">
            @for (regimen of regimens; track regimen) {
              @if (regimen.isPreparationTimePending) {
                <app-banner-wrapper *swiperSlide [spacing]="Spacing.None">
                  <regimen-preparation-banner [regimenClass]="regimen.class"></regimen-preparation-banner>
                </app-banner-wrapper>
              }
            }
          </swiper>
        </app-swiper-wrapper>

        @if (submitDefualtAnswersBannerItems?.length === 1) {
          <app-banner-wrapper appTrackScrollDepth="submit_default_answer">
            <app-submit-defualt-answers-banner
              [consultation]="submitDefualtAnswersBannerItems[0].consultation"
              [thumbnailUrl]="submitDefualtAnswersBannerItems[0].thumbnailUrl"
            ></app-submit-defualt-answers-banner>
          </app-banner-wrapper>
        } @else if (submitDefualtAnswersBannerItems?.length > 1) {
          <app-swiper-wrapper appTrackScrollDepth="submit_default_answer" paginationId="submit-default-answers-swiper-pagination">
            <swiper id="submit-default-answers-swiper" class="submit-defualt-answers-swiper tw-max-w-full" [config]="submitDefaultAnswersCarouselConfig">
              @for (item of submitDefualtAnswersBannerItems; track item.consultation) {
                <app-banner-wrapper *swiperSlide [spacing]="Spacing.None">
                  <app-submit-defualt-answers-banner
                    [consultation]="item.consultation"
                    [thumbnailUrl]="item.thumbnailUrl"
                  ></app-submit-defualt-answers-banner>
                </app-banner-wrapper>
              }
            </swiper>
          </app-swiper-wrapper>
        }
  <!--      Regimen delivered banner -->
        @if (orderDeliveryVideoBannerOrders.length) {
          <app-swiper-wrapper appTrackScrollDepth="order_delivered_video" paginationId="regimen-delivered-pagination">
            <swiper [config]="regimenDeliveredCarouselConfig" #swiperRegimenDelivered id="regimen-delivered-swiper" class="tw-max-w-full tw-overflow-visible">
              @for (order of orderDeliveryVideoBannerOrders; track order.id) {
                <app-banner-wrapper *swiperSlide [spacing]="Spacing.None">
                  <order-delivered appTrackable pageName="homePage" bannerName="order_status" [eventData]="orderStatusEventData" [carousel]="true" [order]="order" (addEvents)="addEvents()" [orderDeliveryBannerVideosExp]="true" [partialVideos]="orderDeliveryPartialVideos" [kitRegimen]="getRegimenForOrder(order)"></order-delivered>
                </app-banner-wrapper>
              }
            </swiper>
          </app-swiper-wrapper>
        }

        <app-swiper-wrapper paginationId="order-banner-pagination">
          <swiper [config]="orderBannerCarouselConfig" #swiperProductTransitCards id="order-banner-swiper" class="tw-max-w-full tw-overflow-visible">
            @if (acqPaymentDropOffExperiment) {
              @for (order of paymentDropOffOrders; track order.id) {
                <payment-drop-off appTrackScrollDepth="payment_drop_off" appTrackable pageName="homePage" bannerName="paymentDropOff" [carousel]="true" *swiperSlide [order]="order"></payment-drop-off>
              }
            }
            @for (order of allActiveOrders; track order.id) {
              @if (order.get('stage') === appConfig.Shared.Order.Stage.DELIVERED && order.get('showOrderDeliveredBanner') && !showOrderDeliveryVideosBanner(order)) {
                <app-banner-wrapper *swiperSlide appTrackScrollDepth="order_delivered" [spacing]="Spacing.None">
                  <order-delivered appTrackable pageName="homePage" bannerName="order_status" [eventData]="orderStatusEventData" [carousel]="true" [order]="order" (addEvents)="addEvents()"></order-delivered>
                </app-banner-wrapper>
              }
              @if (appConfig.Shared.Order.Stage.orderOutForDeliveryStages.includes(order?.get('stage'))) {
                <app-banner-wrapper *swiperSlide appTrackScrollDepth="out_for_delivery" [spacing]="Spacing.None">
                  <out-for-delivery appTrackable pageName="homePage" bannerName="order_status" [eventData]="orderStatusEventData" [carousel]="true" [order]="order" (addEvents)="addEvents()"></out-for-delivery>
                </app-banner-wrapper>
              }
              @if (appConfig.Shared.Order.Stage.orderDispatchedStages.includes(order?.get('stage'))) {
                <app-banner-wrapper *swiperSlide appTrackScrollDepth="order_shipped" [spacing]="Spacing.None">
                  <order-shipped appTrackable pageName="homePage" bannerName="order_status" [eventData]="orderStatusEventData" [carousel]="true" [order]="order" (addEvents)="addEvents()"></order-shipped>
                </app-banner-wrapper>
              }
              @if (appConfig.Shared.Order.Stage.orderPlacedStages.includes(order?.get('stage')) && order?.get('stage') !== appConfig.Shared.Order.Stage.ISOTRETINOIN_CONSENT_PENDING) {
                <app-banner-wrapper *swiperSlide appTrackScrollDepth="order_received" [spacing]="Spacing.None">
                  <order-received appTrackable pageName="homePage" bannerName="order_status" [eventData]="orderStatusEventData" [carousel]="true" [order]="order" (addEvents)="addEvents()"></order-received>
                </app-banner-wrapper>
              }
              @if (appConfig.Shared.Order.Stage.orderPackedStages.includes(order?.get('stage'))) {
                <app-banner-wrapper *swiperSlide appTrackScrollDepth="order_packed" [spacing]="Spacing.None">
                  <packing-order appTrackable pageName="homePage" bannerName="order_status" [eventData]="orderStatusEventData" [carousel]="true" [order]="order" (addEvents)="addEvents()"></packing-order>
                </app-banner-wrapper>
              }
            }
            <!--reply in ticket banner-->
            @if (replyInTicket) {
              <app-banner-wrapper *swiperSlide appTrackScrollDepth="doctor_reply" [spacing]="Spacing.None">
                <doctor-reply appTrackable pageName="homePage" bannerName="doctor_reply" [carousel]="true" [userDoctor]="userDoctor" (viewTicket)="viewTicket()"></doctor-reply>
              </app-banner-wrapper>
            }
          </swiper>
        </app-swiper-wrapper>

        <ng-template #dietBannerTpl>
          <app-banner-wrapper appTrackScrollDepth="diet_banner_new">
            <app-diet-guidance-banner appTrackable pageName="homePage" bannerName="diet_banner_new" class="tw-block  tw-mx-4" [regimen]="dietBannerRegimen" page="home" [isCollapsed]="isDietBannerCollapsed"></app-diet-guidance-banner>
          </app-banner-wrapper>
        </ng-template>

        @if (showDietBannerExpanded) {
          <ng-container [ngTemplateOutlet]="dietBannerTpl"></ng-container>
        }

        <!-- Gamification Banner Position: 2Days (After all order status banners, Above cart) -->
        @if (shouldShowMainGamificationBannerAtPosition('2Days')) {
          <app-banner-wrapper appTrackScrollDepth="gamification_banner">
            <app-gamification-banner
              [todayProductUsageData]="todayProductUsageData"
              [user]="user"
              [regimen]="latestActiveRegimen"
              (scratchCardDismissedWithoutClaim)="onScratchCardDismissedWithoutClaim()"
              (rewardClaimed)="onRewardClaimed($event)">
            </app-gamification-banner>
          </app-banner-wrapper>
        }

        <!--      Nutra banners  -->
        @if (nutraBannerExperiment && showNutraBanner && (user?.get('orderState') === appConfig.Shared.User.OrderState.DELIVERED)) {
          <app-swiper-wrapper appTrackScrollDepth="nutra_repeat" paginationId="nutra-pagination">
            <swiper appTrackable pageName="homePage" bannerName="nutra_repeat" [config]="nutraCarouselConfig" class="tw-max-w-full tw-overflow-visible">
              @for (eachBanner of nutraBannerData; track eachBanner) {
                <app-banner-wrapper *swiperSlide [spacing]="Spacing.None" [width]="BannerWidth.Inset">
                  <div class="tw-w-full tw-aspect-[41/24] tw-bg-cover tw-bg-right-bottom tw-bg-no-repeat tw-rounded-3 tw-overflow-hidden tw-px-6 tw-py-[26px]"
                       [style.background-image]="'url(' + eachBanner?.bannerImage + ')'"
                       (click)="openVariantsPopup(eachBanner?.margId)">
                    <div class="tw-w-1/2 tw-font-body">
                      <h1 class="tw-text-700 tw-font-[700] tw-leading-6 tw-mb-1 tw-font-lexend" i18n="@@runningLow">Running Low?</h1>
                      <p class="tw-text-200 tw-font-medium tw-leading-[1.2] tw-mb-4" i18n="@@stayOnTrack">Stay on track <br/> with your results.</p>
                      <div
                        class="tw-bg-teal-600 tw-text-white tw-text-300 tw-font-[700] tw-relative shine-button tw-overflow-hidden tw-py-2 tw-rounded-3 tw-text-center tw-w-max tw-px-4"
                        i18n="@@reorderNow">Reorder Now</div>
                    </div>
                  </div>
                </app-banner-wrapper>
              }
            </swiper>
          </app-swiper-wrapper>
        }
        @if (user?.get('orderState') === appConfig.Shared.User.OrderState.DELIVERED && isAovSaleLive && isAOVActive) {
          <app-banner-wrapper appTrackScrollDepth="aov">
            <section appTrackable pageName="homePage" [bannerName]="'aov'" class="banners bogoSale tw-mx-4 bdr-rad-15" (click)="openAovBanner()">
              <img [src]="aovBannerImage" />
            </section>
          </app-banner-wrapper>
        }
        @if (userStatus.PAID && isBOGOSaleLive) {
          <app-banner-wrapper appTrackScrollDepth="bogo">
            <section appTrackable pageName="homePage" [bannerName]="'bogo'" class="banners bogoSale tw-mb-0" (click)="openBogoBanner()">
              <img [src]="saleBannerImage" />
            </section>
          </app-banner-wrapper>
        }
        @if (userStatus.PAID && isSaleLive) {
          <app-banner-wrapper appTrackScrollDepth="sale_offer">
            <section appTrackable pageName="homePage" [bannerName]="'sale_offer'" class="banners bogoSale tw-mb-0" (click)="openSaleBanner()">
              <img [src]="bannerImage" />
            </section>
          </app-banner-wrapper>
        }

        <!-- Cart banners -->
        @if (productsInCart?.length || recommendedItems?.length) {
          <div class="tw-relative levelFourBanners">
            @if (voiceNoteByScript && userStatus.PAID) {
              <app-banner-wrapper appTrackScrollDepth="voice_note_script">
                <app-voice-note-banner-script appTrackable pageName="homePage" [bannerName]="'voice_note_script'" (goToCart)="goToCart()" [userDrImage]="userDrImage" [productsInCart]="productAddedByScript" (emitTrackEvent)="trackEventOne($event)" [user]="user"></app-voice-note-banner-script>
              </app-banner-wrapper>
            }
            @if (productsInCart.length > 1 && userStatus.PAID && !voiceNoteByScript && !showSuggestedForYouBanner) {
              <app-banner-wrapper appTrackScrollDepth="cart_multiple_products">
                <app-complete-your-multiple-order
                  appTrackable pageName="homePage" bannerName="cart_multiple_products"
                  elementInViewport
                  [viewportMargin]="'0px'"
                  [viewportThreshold]="0"
                  [viewportRoot]="null"
                  (viewportVisibilityChange)="handleCompleteOrderBannerVisibility($event)"
                  (goToCart)="goToCart()"
                  [userDrImage]="userDrImage"
                  [productsInCart]="productsInCart"
                  [toolbarIcons]="toolbarIcons"
                  [cartDiscount]="cartDiscount"
                  [totalSp]="totalSP"
                  [cartScriptBannerHeaderExperiment]="cartScriptBannerHeaderExperiment"
                >
                </app-complete-your-multiple-order>
              </app-banner-wrapper>
            }
            @if (productsInCart.length === 1 && userStatus.PAID && !voiceNoteByScript && !showSuggestedForYouBanner) {
              <app-banner-wrapper appTrackScrollDepth="cart_single_product">
                <complete-your-order
                  appTrackable pageName="homePage" bannerName="cart_single_product"
                  elementInViewport
                  [viewportMargin]="'0px'"
                  [viewportThreshold]="0"
                  [viewportRoot]="null"
                  (viewportVisibilityChange)="handleCompleteOrderBannerVisibility($event)"
                  (goToCart)="goToCart()"
                  [productsInCart]="productsInCart"
                  [cartDiscount]="cartDiscount"
                  [totalSp]="totalSP"
                  [userDrImage]="userDrImage"
                  [cartScriptBannerHeaderExperiment]="cartScriptBannerHeaderExperiment"
                >
                </complete-your-order>
              </app-banner-wrapper>
            }
            @if (showSuggestedForYouBanner && userStatus.PAID && !voiceNoteByScript) {
              <app-banner-wrapper appTrackScrollDepth="suggested_for_you">
                <suggested-for-you appTrackable pageName="homePage" bannerName="cart_single_product" (goToCart)="addProductToCart($event)" [recommendedItems]="recommendedItems" [productsInCart]="productsInCart" [cartDiscount]="cartDiscount" [totalSp]="totalSP"></suggested-for-you>
              </app-banner-wrapper>
            }
          </div>
        }

        <!--slider-->
        <app-swiper-wrapper paginationId="main-swiper-pagination">
        <swiper id="main-swiper" class="home-page-swiper tw-max-w-full" [ngClass]="{'tw-overflow-visible': isMainSwiperMounted}" #swiperCardsBannerMain [config]="carouselConfig" (afterInit)="onAfterInitOfMainSwiper()">
          @for (regimen of regimens; track regimen) {
            @if (!regimen.isPreparationTimePending && !regimen.active && !regimen.orderPlaced && regimen.class !== appConfig.Shared.Regimen.Class.BODY) {
              <div *swiperSlide class="tw-flex tw-flex-col tw-gap-4">
                <app-banner-wrapper appTrackScrollDepth="regimen_kit_ready" [spacing]="Spacing.None">
                  <div class="card tw-flex tw-flex-col tw-items-center tw-mx-4 tw-bg-white tw-rounded-[15px]" [ngClass]="{'tw-h-auto': !resetKitReadyBannerHeight, 'tw-h-0': resetKitReadyBannerHeight}">
                    <regimen-kit-ready appTrackable pageName="homePage" [bannerName]="'regimen_kit_ready_' + regimen.class" [carousel]="true" [class]="regimen.class" [coverImage]="regimen?.regimenCoverImage" [user]="this.user" [userName]="this.userName" [regimen]="regimen" [doctorImage]="userDrImage" [showDoubleCta]="showRegimenReadyDualCta"></regimen-kit-ready>
                  </div>
                </app-banner-wrapper>
              </div>
            }
          }
          <!-- re-acquisition banners-->
          <!--want to take dr checkup-->
          @if (reAcquisitionBannerType == 'reAcquisitionBannerReady') {
            <app-banner-wrapper *swiperSlide appTrackScrollDepth="reacquisition_start_checkup_banner" [spacing]="Spacing.None">
              <doctor-checkup-reminder-banner appTrackable bannerName="reacquisition_start_checkup_banner" [carousel]="true" [doctorDetails]="doctorDetails" (actionClick)="navigateToReAcquisitionFlow('reAcquisitionBannerReady')">
                <span i18n="@@restartYourRoutine">Hi <span class="tw-capitalize">{{ user?.get('PatientName') }}</span>, restart your routine with a free doctor checkup</span>
              </doctor-checkup-reminder-banner>
            </app-banner-wrapper>
          }

          @if (reAcquisitionBannerType === 'reAcquisitionCheckupPending') {
            <app-banner-wrapper *swiperSlide appTrackScrollDepth="reacquisition_checkup_incomplete" [spacing]="Spacing.None">
              <incomplete-banner appTrackable bannerName="reacquisition_checkup_incomplete" [carousel]="true" [userFirstName]="userFirstName" (click)="navigateToReAcquisitionFlow('reAcquisitionCheckupPending')"></incomplete-banner>
            </app-banner-wrapper>
          }
          <!-- waiting for doctor call-->
          @if (reAcquisitionBannerType === 'waitingForReAcquisitionCall') {
            <app-banner-wrapper *swiperSlide appTrackScrollDepth="reacquisition_checkup_scheduled" [spacing]="Spacing.None">
              <processing-banner appTrackable pageName="homePage" bannerName="reacquisition_checkup_scheduled" [carousel]="true">
                <h1 slot="header" class="tw-text-400 tw-mb-[17px] tw-text-gray-800 tw-w-[70%]">
                  @switch (timeService.getDoctorCallTiming()) {
                    @case ('working') {
                      <span i18n="@@doctorCallWithin2To3Hours">Your doctor will call you within 2-3 hours</span>
                    }
                    @case ('evening') {
                      <span i18n="@@doctorCallTomorrow">Your doctor will call you tomorrow</span>
                    }
                    @case ('early') {
                      <span i18n="@@doctorCallAfter8AMToday">Your doctor will call you after 8 AM today</span>
                    }
                  }
                </h1>
                <p slot="sub-header" class="tw-text-gray-800 tw-font-bold tw-text-200 tw-w-[32%] tw-leading-[15px]" i18n="@@yourCheckupIsInProcess">Your checkup is in progress</p>
                <img slot="doctor-image" src="https://cdn.cureskin.com/app/img/dr_charu_single.png" alt="Doctor" class="tw-w-[125px] tw-object-cover tw-shadow-lg"/>
              </processing-banner>
            </app-banner-wrapper>
          }
          <!-- missed doctor call-->
          @if (reAcquisitionBannerType === 'missedReAcquisitionCall') {
            <app-banner-wrapper *swiperSlide appTrackScrollDepth="reacquisition_call_rnr" [spacing]="Spacing.None">
              <missed-doctor-call appTrackable bannerName="reacquisition_call_RNR" [carousel]="true" [userFirstName]="userFirstName"></missed-doctor-call>
            </app-banner-wrapper>
          }
          <!-- FOLLOWUP BANNERS along with Level 2 banners-->
          <!-- Follow up report created-->
          @if (followUpReport) {
            <app-banner-wrapper *swiperSlide appTrackScrollDepth="report_created" [spacing]="Spacing.None">
              <report-is-ready appTrackable pageName="homePage" bannerName="report_created" [carousel]="true" (openFollowUpReport)="openFollowUpReport()"></report-is-ready>
            </app-banner-wrapper>
          }
          <!-- Checkup is scheduled on next two days-->
          @if (selectedFollowUpBanner === 'followUpScheduledInTwoDays') {
            @if (selfCheckupWindowDetermined) {
              @if (isWithinSelfCheckupWindow) {
                <app-banner-wrapper *swiperSlide appTrackScrollDepth="self_checkup_photo" [spacing]="Spacing.None">
                  <app-self-checkup-banner [daysSinceLastDelivery]="selfCheckupDaysSinceLastDelivery" appTrackable pageName="homePage" bannerName="self_checkup_photo" [carousel]="true" [user]="user" [instantCheckups]="instantCheckups"></app-self-checkup-banner>
                </app-banner-wrapper>
              }
              @if (!isWithinSelfCheckupWindow) {
                <app-banner-wrapper *swiperSlide appTrackScrollDepth="checkup_due" [spacing]="Spacing.None">
                  <doctor-checkup-reminder-banner appTrackable pageName="homePage" [bannerName]="'checkup_due'" [carousel]="true" [doctorDetails]="doctorDetails" (actionClick)="handleCheckupBannerClick()">
                    <span i18n="@@hiYourDoctorCheckupIsDueToday">Hi <span class="tw-capitalize">{{ user?.get('PatientName') }}</span>, Your doctor checkup is due today</span>
                  </doctor-checkup-reminder-banner>
                </app-banner-wrapper>
              }
            }
          }
          <!-- anytime followUpEnabled-->
          @if (selectedFollowUpBanner === 'anyTimeFollowUpEnabled') {
            @if (selfCheckupWindowDetermined) {
              @if (isWithinSelfCheckupWindow) {
                <app-banner-wrapper *swiperSlide appTrackScrollDepth="self_checkup_photo" [spacing]="Spacing.None">
                  <app-self-checkup-banner [daysSinceLastDelivery]="selfCheckupDaysSinceLastDelivery" [user]="user" [instantCheckups]="instantCheckups"></app-self-checkup-banner>
                </app-banner-wrapper>
              }
              @if (!isWithinSelfCheckupWindow) {
                <app-banner-wrapper *swiperSlide appTrackScrollDepth="checkup_due" [spacing]="Spacing.None">
                  <doctor-checkup-reminder-banner appTrackable pageName="homePage" [bannerName]="'checkup_due'" [carousel]="true" [doctorDetails]="doctorDetails" (actionClick)="handleCheckupBannerClick()">
                    <span i18n="@@hiYourDoctorCheckupIsDueToday">Hi <span class="tw-capitalize">{{ user?.get('PatientName') }}</span>, Your doctor checkup is due today</span>
                  </doctor-checkup-reminder-banner>
                </app-banner-wrapper>
              }
            }
          }
          <!-- followUp waitingForImage-->
          @if (selectedFollowUpBanner === 'followUpWaitingForImage') {
            <app-banner-wrapper *swiperSlide appTrackScrollDepth="blur_photo" [spacing]="Spacing.None">
              <requesting-photo appTrackable pageName="homePage" bannerName="blur_photo" [carousel]="true" (startFollowUp)="startFollowUp('WAITING_FOR_IMAGE_BANNER_CLICKED')"></requesting-photo>
            </app-banner-wrapper>
          }
          <!-- followUp is ready waiting for report creation-->
          @if (selectedFollowUpBanner === 'followUpReadyWaitingForReport' && !festivalDelayBannerEnabled) {
            <app-banner-wrapper *swiperSlide appTrackScrollDepth="creating_report" [spacing]="Spacing.None">
              <report-getting-ready appTrackable pageName="homePage" bannerName="creating_report" [carousel]="true"></report-getting-ready>
            </app-banner-wrapper>
          }
          <!-- last followUp is skipped-->
          @if (selectedFollowUpBanner === 'lastFollowUpSkipped') {
            @if (selfCheckupWindowDetermined) {
              @if (isWithinSelfCheckupWindow) {
                <app-banner-wrapper *swiperSlide appTrackScrollDepth="self_checkup_photo" [spacing]="Spacing.None">
                  <app-self-checkup-banner [user]="user" [daysSinceLastDelivery]="selfCheckupDaysSinceLastDelivery" [instantCheckups]="instantCheckups"></app-self-checkup-banner>
                </app-banner-wrapper>
              }
              @if (!isWithinSelfCheckupWindow) {
                <app-banner-wrapper *swiperSlide appTrackScrollDepth="checkup_due" [spacing]="Spacing.None">
                  <doctor-checkup-reminder-banner appTrackable pageName="homePage" [carousel]="true" [bannerName]="'checkup_due'" [doctorDetails]="doctorDetails" (actionClick)="handleCheckupBannerClick()">
                    <span i18n="@@hiYourDoctorCheckupIsDueToday">Hi <span class="tw-capitalize">{{ user?.get('PatientName') }}</span>, Your doctor checkup is due today</span>
                  </doctor-checkup-reminder-banner>
                </app-banner-wrapper>
              }
            }
          }
          @if (notListenedVoiceMessage && showVoiceNoteBanner && user?.get('allocatedDoctor')) {
            <app-banner-wrapper appTrackScrollDepth="voice_note" *swiperSlide [spacing]="Spacing.None">
              <app-voice-note-banner
                appTrackable pageName="homePage"
                bannerName="voice_note"
                [carousel]="true"
                [docImg]="voiceNoteBannerDetails.doctorDisplayImageURL || defaultDoctorImage"
                [voiceUrl]="voiceNoteBannerDetails.voiceUrl"
                [trackEventAudio]="voiceNoteBannerDetails.trackEventAudio"
                [message]="voiceNoteBannerDetails.message"
                [doctorName]="voiceNoteBannerDetails?.doctorName"
                [kitImageUrl]="voiceNoteBannerDetails?.regimenCoverImageUrl"
                [isDoctorVerifiedKit]="isDoctorVerifiedKit"
                [regimen]="regimen"
                [orderChatId]="notListenedVoiceMessage?.id"
                (trackVoiceEvent)="trackVoiceEvent(swiperCardsBannerMain,$event)"
                (languageChanged)="refreshVoiceNote()"
              ></app-voice-note-banner>
            </app-banner-wrapper>
          }
          <!--Unpaid state-->
          <!--Incomplete chat-->
          @if (consultationSession) {
            @if (concernClass) {
              @if (isFaceChatPending) {
                <app-banner-wrapper *swiperSlide appTrackScrollDepth="incomplete_chat_face" [spacing]="Spacing.None">
                <div appTrackable pageName="homePage" bannerName='incomplete_chat_face' [carousel]="true" id="face" #face
                     class="tw-gap-4 tw-rounded-2xl tw-mx-4 tw-shadow-z1 tw-relative tw-bg-white tw-bg-grid-fade-rtl tw-bg-contain tw-bg-right-bottom tw-bg-no-repeat"
                     (click)="openChatFromNewIncompleteChatBanner($event)">
                  <div
                    class="tw-flex tw-gap-2 tw-justify-start tw-items-center tw-bg-teal-100 tw-rounded-tl-4 tw-rounded-tr-4 tw-py-3 tw-px-4">
                    <span class="tw-w-2 tw-h-2 tw-bg-red-400 tw-rounded-full"></span>
                    @if (isRegimenExpired) {
                      <h1 class="tw-text-teal-600 tw-font-medium tw-text-200" i18n="@@completeSkinChatToRestartTreatment">Complete skin chat to restart treatment</h1>
                    } @else {
                      <h1 class="tw-text-teal-600 tw-font-medium tw-text-200" i18n="@@yourSkinTreatment">Your Skin Treatment</h1>
                    }
                  </div>
                  <div class="tw-py-5 tw-px-5">
                    <div class="tw-text-300">
                      <div class="tw-flex tw-justify-start tw-items-center tw-mb-[1px]" [ngClass]="{'tw-gap-1': [appConfig.Shared.Languages.ML, appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference'))}">
                            <span class="tw-flex tw-flex-1 tw-items-center">
                              <p class="" i18n="@@name">Name</p>:
                            </span>
                        <p class="tw-flex-1 tw-capitalize">{{ userFirstName }}</p>
                      </div>
                      <div class="tw-flex tw-justify-start tw-items-center tw-mb-[1px]" [ngClass]="{'tw-gap-1': [appConfig.Shared.Languages.ML, appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference'))}">
                            <span class="tw-flex tw-flex-1 tw-items-center">
                              <p class="" i18n="@@age">Age</p>:
                            </span>
                        <p class="tw-flex-1">{{ userAge }} yrs</p>
                      </div>
                      <div class="tw-flex tw-justify-start tw-items-center">
                          <span class="tw-flex tw-flex-1 tw-items-center">
                            <p [ngClass]="{'tw-leading-4 tw-max-w-28 tw-text-wrap' : user.get('languagePreference') === 'ta'}" i18n="@@selectedConcern">Selected Concern</p>:
                          </span>
                        <p class="tw-flex-1 tw-font-bold tw-text-orange-400 tw-h-4 tw-leading-none tw-flex tw-justify-start tw-items-start">{{ faceDisplayConcern }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="tw-flex tw-justify-center tw-items-center tw-px-4 tw-pb-4">
                      <span i18n="@@continueChatFull"
                            class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-2 tw-px-8 tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold shine-button tw-relative tw-overflow-hidden">
                        Continue chat
                      </span>
                  </div>
                </div>
                </app-banner-wrapper>
              }
              @if (isHairChatPending) {
                <app-banner-wrapper *swiperSlide appTrackScrollDepth="incomplete_chat_hair" [spacing]="Spacing.None">
                  <div appTrackable pageName="homePage" bannerName='incomplete_chat_hair' [carousel]="true" id="hair" #hair
                     class="tw-gap-4 tw-rounded-2xl tw-mx-4 tw-shadow-z1 tw-relative tw-bg-white tw-bg-grid-fade-rtl tw-bg-contain tw-bg-right-bottom tw-bg-no-repeat"
                     (click)="openChatFromNewIncompleteChatBanner($event)">
                  <div
                    class="tw-flex tw-gap-2 tw-justify-start tw-items-center tw-bg-teal-100 tw-rounded-tl-4 tw-rounded-tr-4 tw-py-3 tw-px-4">
                    <span class="tw-w-2 tw-h-2 tw-bg-red-400 tw-rounded-full"></span>
                    @if (isRegimenExpired) {
                      <h1 class="tw-text-teal-600 tw-font-medium tw-text-200" i18n="@@completeHairChatToRestartTreatment">Complete hair chat to restart treatment</h1>
                    } @else {
                      <h1 class="tw-text-teal-600 tw-font-medium tw-text-200" i18n="@@yourHairTreatment">Your Hair Treatment</h1>
                    }
                  </div>
                  <div class="tw-py-5 tw-px-5">
                    <div class="tw-text-300">
                      <div class="tw-flex tw-justify-start tw-items-center tw-mb-[1px]">
                            <span class="tw-flex tw-flex-1 tw-items-center">
                              <p class="" i18n="@@name">Name</p>:
                            </span>
                        <p class="tw-flex-1 tw-capitalize">{{ userFirstName }}</p>
                      </div>
                      <div class="tw-flex tw-justify-start tw-items-center tw-mb-[1px]">
                            <span class="tw-flex tw-flex-1 tw-items-center">
                              <p class="" i18n="@@age">Age</p>:
                            </span>
                        <p class="tw-flex-1">{{ userAge }} yrs</p>
                      </div>
                      <div class="tw-flex tw-justify-start tw-items-center">
                          <span class="tw-flex tw-flex-1 tw-items-center">
                            <p [ngClass]="{'tw-leading-4 tw-max-w-28 tw-text-wrap' : user.get('languagePreference') === 'ta'}" i18n="@@selectedConcern">Selected Concern</p>:
                          </span>
                        <p class="tw-flex-1 tw-font-bold tw-text-orange-400 tw-h-4 tw-flex tw-justify-start tw-items-start tw-leading-none">{{ hairDisplayConcern }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="tw-flex tw-justify-center tw-items-center tw-px-4 tw-pb-4">
                      <span i18n="@@continueChatFull"
                            class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-2 tw-px-8 tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold shine-button tw-relative tw-overflow-hidden">
                        Continue chat
                      </span>
                  </div>
                  </div>
                </app-banner-wrapper>
              }
            }
          }
          <!--request for data-->
          @if (requestDataInTicket) {
            <app-banner-wrapper *swiperSlide appTrackScrollDepth="request_data" [spacing]="Spacing.None">
              <request-data appTrackable pageName="homePage" bannerName='request_data' [carousel]="true" [userDoctor]="userDoctor" (viewTicket)="viewTicket()"></request-data>
            </app-banner-wrapper>
          }
          <!--festival banner-->
          @if (selectedFollowUpBanner === 'followUpReadyWaitingForReport' && festivalDelayBannerEnabled) {
            <app-banner-wrapper *swiperSlide appTrackScrollDepth="festive" [spacing]="Spacing.None">
              <festive-banner appTrackable pageName="homePage" bannerName='festive' [carousel]="true"></festive-banner>
            </app-banner-wrapper>
          }
        </swiper>
        </app-swiper-wrapper>

        @if (canShowFollowupQuestionsWidget()) {
          <app-banner-wrapper appTrackScrollDepth="follow_up_questions_banner">
            <div appTrackable bannerName="follow_up_questions_banner" pageName="homePage" class="tw-mx-4">
              <app-follow-up-questions-widget
                [followUp]="followUp()"
                [user]="user"
                [userImageUrl]="followupQuestionsWidgetImage"
                placement="inline"
                (completed)="onFollowupQuestionsCompleted()"
                (fallbackToChat)="onFollowupQuestionsFallback()">
              </app-follow-up-questions-widget>
            </div>
          </app-banner-wrapper>
        }

        <!--Complete your profile (retention users)-->
        @if (showCompleteYourProfileTop) {
          <app-banner-wrapper appTrackScrollDepth="complete_your_profile">
            <complete-your-profile
              appTrackable pageName="homePage" bannerName="complete_your_profile"
              [eventData]="completeProfileEventData"
              class="tw-block"
              [gender]="user?.get('Gender')"
              [sections]="completeProfileSections">
            </complete-your-profile>
          </app-banner-wrapper>
        }

        @if(showRegimenReorderBanner && regimenReorderKitDetails?.length) {
          @if(regimenReorderKitDetails?.length === 1) {
            <app-banner-wrapper appTrackScrollDepth="regimen_reorder">
              <regimen-reorder-banner [bannerDetail]="regimenReorderKitDetails[0]" [orderState]="user?.get('orderState')"></regimen-reorder-banner>
            </app-banner-wrapper>
          } @else {
            <app-swiper-wrapper appTrackScrollDepth="regimen_reorder" paginationId="reorder-swiper-pagination">
              <swiper id="reorder-swiper" class="tw-max-w-full" [config]="reorderCarouselConfig">
                @for (regimenReorderKitDetail of regimenReorderKitDetails; track regimenReorderKitDetail) {
                  <app-banner-wrapper *swiperSlide [spacing]="Spacing.None">
                    <regimen-reorder-banner [bannerDetail]="regimenReorderKitDetail" [orderState]="user?.get('orderState')"></regimen-reorder-banner>
                  </app-banner-wrapper>
                }
              </swiper>
            </app-swiper-wrapper>
          }
        }
        <!-- Regimen going to expire banner-->
        @if (regimenExpiryExperiment && regimenExpiryBannerData?.showBanner) {
        <app-banner-wrapper appTrackScrollDepth="regimen_expiry">
          <regimen-expiry-banner appTrackable bannerName="regimen_will_expire" [eventData]="regimenExpiryEventData" [regimenExpiryBannerData]="regimenExpiryBannerData" (buttonClick)="handleRegimenExpiryBannerClick()">
            <p slot="header" class="tw-font-bold tw-text-500 tw-leading-[22px] tw-font-lexend tw-text-black tw-text-center">
              @if (regimenExpiryBannerData?.regimenExpireIn === 0) {
                <span i18n="@@yourDoctorCheckupsWillBeBlockedToday"><span class="tw-capitalize">{{this.userFirstName}}</span>, your doctor check-ups <br /> will be blocked today!</span>
              } @else if (regimenExpiryBannerData?.regimenExpireIn === 1) {
                <span i18n="@@yourDoctorCheckupsWillBeBlockedTomorrow"><span class="tw-capitalize">{{this.userFirstName}}</span>, your doctor check-ups <br /> will be blocked tomorrow!</span>
              } @else if (regimenExpiryBannerData?.regimenExpireIn > 1 && regimenExpiryBannerData?.regimenExpireIn <= 10) {
                <span i18n="@@yourDoctorCheckupsWillBeBlockedInDays"><span class="tw-capitalize">{{this.userFirstName}}</span>, your doctor check-ups <br /> will be blocked in {{regimenExpiryBannerData?.regimenExpireIn}} days!</span>
              } @else {
                <span i18n="@@yourDoctorCheckupsWillBeBlockedSoon"><span class="tw-capitalize">{{this.userFirstName}}</span>, your doctor check-ups <br /> will be blocked soon!</span>
              }
            </p>
            <p slot="sub-header" class="tw-font-body tw-font-normal tw-text-200 tw-leading-[17px] tw-text-gray-800 tw-text-center tw-mt-1" i18n="@@notFollowingYourTreatment"> Since we noticed you are not following your <br /> entire treatment as prescribed </p>
            <div slot="button" class="tw-w-max tw-m-auto tw-mt-4 tw-bg-teal-600 tw-rounded-2 tw-text-400 tw-text-white tw-font-bold tw-font-body tw-px-8 tw-py-[10px] tw-text-nowrap tw-align-baseline">
              @if (regimenExpiryBannerData?.redirectToFollowUp) {
                <span i18n="@@takeCheck-upNow">Take Check-up Now</span>
              } @else {
                <span i18n="@@unlockMoreCheckupUps">Unlock More Check-ups </span>
              }
            </div>
          </regimen-expiry-banner>
        </app-banner-wrapper>
        }

        <!-- Regimen expired banner-->
        @if (showRegimenExpiredBanner) {
          <app-banner-wrapper appTrackScrollDepth="regimen_expired_banner">
            <regimen-expired-banner appTrackable pageName="homePage" bannerName="regimen_expired_banner" [regimenExpiredBannerData]="regimenExpiredBannerData" (hideBanner)="hideRegimenExpiredBanner()"></regimen-expired-banner>
          </app-banner-wrapper>
        }

        @if (isRecommendedProductsShown) {
          <app-banner-wrapper>
            <recommended-products appTrackable pageName="homePage" bannerName="home-recommended-products"
                                  [products]="recommendedProducts.products" [displayType]="recommendedProducts.displayType"></recommended-products>
          </app-banner-wrapper>
        } @else if (shouldShowRecentlyViewedSection) {
          <app-banner-wrapper appTrackScrollDepth="recently_viewed">
            <recently-viewed-products
              appTrackable
              pageName="homePage"
              bannerName="recently_viewed_products"
              [location]="recentlyViewedLocation.HOME"
              [recentlyViewedData]="recentlyViewedData"
              [cartData]="getCartDataForRecentlyViewed()">
            </recently-viewed-products>
          </app-banner-wrapper>
        }
        <!-- Restock Banner ("Time to Refill") -->
        @if (isRestockBannerVisible()) {
          <app-banner-wrapper>
            <app-restock-banner appTrackable pageName="homePage" bannerName="restock_banner"
                                (visibilityChange)="setRestockBannerVisible($event)"></app-restock-banner>
          </app-banner-wrapper>
        }

        <!-- Gamification Banner Position: 4days (Below recently viewed, Above cross-sell) -->
        @if (shouldShowMainGamificationBannerAtPosition('4days')) {
          <app-banner-wrapper appTrackScrollDepth="gamification_banner">
            <app-gamification-banner
              [todayProductUsageData]="todayProductUsageData"
              [user]="user"
              [regimen]="latestActiveRegimen"
              (scratchCardDismissedWithoutClaim)="onScratchCardDismissedWithoutClaim()"
              (rewardClaimed)="onRewardClaimed($event)">
            </app-gamification-banner>
          </app-banner-wrapper>
        }
        @if (reAcquisitionBannerType === 'missedReAcquisitionCall') {
          <app-banner-wrapper appTrackScrollDepth="reacquisition_call_rnr">
            <missed-doctor-call appTrackable bannerName="reacquisition_call_RNR" [carousel]="true" *swiperSlide [userFirstName]="userFirstName"></missed-doctor-call>
          </app-banner-wrapper>
        }
        <!--      nutra push banner -->
        @if (nutraPushBannerData && nutraPushBottomSheetData?.objectId && regimensClass?.length) {
          <app-banner-wrapper appTrackScrollDepth="nutra_push">
            <div appTrackable pageName="homePage" [bannerName]="'nutra_push'" [eventData]="{type: nutraPushBottomSheetData?.objectId}">
              <nutra-push-banner [nutraPushBannerData]="nutraPushBannerData" [nutraPushExperimentVariantData]="nutraPushExperimentVariantData" [nutraPushBottomSheetData]="nutraPushBottomSheetData" [cartItems]="cartItems" [regimensClass]="regimensClass"></nutra-push-banner>
            </div>
          </app-banner-wrapper>
        }

        @if (isRegimenExtraProductBannerVisible) {
          <app-banner-wrapper appTrackScrollDepth="regimen_offer">
            <app-regimen-offer-product-banner (click)="regimenOfferProduct();" class="tw-mx-4 tw-box-border">
              <app-regimen-offer-tag><span i18n="@@limitedTimeOfferPouch">Limited time offer</span></app-regimen-offer-tag>
              <regimen-offer-product-title><span i18n="@@freePouch">+ Free Pouch</span></regimen-offer-product-title>
              <regimen-offer-product-caption><span i18n="@@withYourPurchase">with your treatment kit purchase</span></regimen-offer-product-caption>
            </app-regimen-offer-product-banner>
          </app-banner-wrapper>
        }

        @if (shouldShowTakePhotoBanner) {
          <app-banner-wrapper appTrackScrollDepth="take_photo">
            @if (takePhotoBannerTrigerringStates?.orderWaitingForImage) {
              <take-photo-banner appTrackable pageName="homePage" bannerName="take_photo" [channels]="PRIMARY_CHANNELS" class="tw-mx-4 tw-box-border" (click)="handleTakePhotoBannerClick()" [userLanguage]="userLanguage">
                <take-photo-banner-title> <span i18n="@@takeLatestPhotoNow"> Take latest photo now </span> </take-photo-banner-title>
                <take-photo-banner-caption> <span i18n="@@asRequestedByYourDoctor"> as requested by your doctor </span> </take-photo-banner-caption>
              </take-photo-banner>
            }
            @if (takePhotoBannerTrigerringStates?.orderPlacedWithoutCheckup) {
              <take-photo-banner appTrackable pageName="homePage" bannerName="take_photo" [channels]="PRIMARY_CHANNELS" class="tw-mx-4 tw-box-border" (click)="handleTakePhotoBannerClick()" [userLanguage]="userLanguage">
                <take-photo-banner-title> <span i18n="@@trackVisibleImprovement"> Track visible improvement </span> </take-photo-banner-title>
                <take-photo-banner-caption> <span i18n="@@byAddingPhotosEveryMonth"> by adding photos every month </span> </take-photo-banner-caption>
              </take-photo-banner>
            }
            @if (takePhotoBannerTrigerringStates?.firstRegimenWithoutCheckup) {
              <take-photo-banner appTrackable pageName="homePage" bannerName="take_photo" [channels]="PRIMARY_CHANNELS" class="tw-mx-4 tw-box-border" (click)="handleTakePhotoBannerClick()" [userLanguage]="userLanguage">
                <take-photo-banner-title> <span i18n="@@trackVisibleImprovement"> Track visible improvement </span> </take-photo-banner-title>
                <take-photo-banner-caption> <span i18n="@@byAddingPhotosEveryMonth"> by adding photos every month </span> </take-photo-banner-caption>
              </take-photo-banner>
            }
          </app-banner-wrapper>
        }

        @if (feedback) {
          <app-banner-wrapper appTrackScrollDepth="nps_feedback">
            <n-p-s-banner appTrackable pageName="homePage" bannerName='NPS_feedback' [feedback]="feedback"></n-p-s-banner>
          </app-banner-wrapper>
        }

        @if (showCrossRegimenBannerTop) {
          <app-banner-wrapper [appTrackScrollDepth]="crossSellScrollBannerName">
            <cross-regimen-banner-v2
              appTrackable pageName="homePage"
              [bannerName]="crossSellScrollBannerName"
              [latestActiveRegimen]="latestActiveRegimen"
              [user]="user"
            ></cross-regimen-banner-v2>
          </app-banner-wrapper>
        }
        <!-- Gamification Banner Position: 5Days+ (Below cross-sell, Above weekly journey) -->
        @if (shouldShowMainGamificationBannerAtPosition('5Days+')) {
          <app-banner-wrapper appTrackScrollDepth="gamification_banner">
            <app-gamification-banner
              [todayProductUsageData]="todayProductUsageData"
              [user]="user"
              [regimen]="latestActiveRegimen"
              (scratchCardDismissedWithoutClaim)="onScratchCardDismissedWithoutClaim()"
              (rewardClaimed)="onRewardClaimed($event)">
            </app-gamification-banner>
          </app-banner-wrapper>
        }

        @if (!userStatus.PAID && unpaidUserChatBotExperiment) {
          <app-banner-wrapper appTrackScrollDepth="unpaid_user_ai_chat">
            <div class="tw-bg-white tw-px-4 tw-py-[17px]">
              <app-user-query-chat-banner [user]="user" [showHeader]="false" [regimen]="latestUnBoughtRegimen" [homePageView]="true"></app-user-query-chat-banner>
            </div>
          </app-banner-wrapper>
        }

        @if (showAcqShopBanner) {
          <app-banner-wrapper appTrackScrollDepth="acquisition_shop_banner">
            <shop-navigate-banner appTrackable pageName="homePage" bannerName='acquisition_shop_banner' [isAcqShop]="true"></shop-navigate-banner>
          </app-banner-wrapper>
        } @else if (showAcqShopProductsBanner) {
          <app-banner-wrapper appTrackScrollDepth="acq_shop_products">
            <acq-shop-products-banner appTrackable pageName="homePage" bannerName='acquisition_shop_products_banner'></acq-shop-products-banner>
          </app-banner-wrapper>
        }
        <!--Complete your profile (acquisition users)-->
        @if (showCompleteYourProfileBottom) {
          <app-banner-wrapper appTrackScrollDepth="complete_your_profile">
            <complete-your-profile
              appTrackable pageName="homePage" bannerName="complete_your_profile"
              [eventData]="completeProfileEventData"
              class="tw-block"
              [gender]="user?.get('Gender')"
              [sections]="completeProfileSections">
            </complete-your-profile>
          </app-banner-wrapper>
        }
        <!--take photo banner-->
        @if (showAnalysisBannerTop) {
          <app-banner-wrapper appTrackScrollDepth="instant_checkup">
            <app-analysis-banner appTrackable pageName="homePage" bannerName='instant_checkup' [channels]="PRIMARY_CHANNELS" (analysisOfTheDay)="analysisOfTheDay()"></app-analysis-banner>
          </app-banner-wrapper>
        }

        @if (!userStatus.PAID) {
          <app-banner-wrapper appTrackScrollDepth="testimonial_widget">
            <testimonials-widget [concernClass]="concernClass || regimenKit" [language]='user?.get("languagePreference") || appConfig.Shared.Languages.EN' [gender]='user.get("Gender") || appConfig.Shared.Gender.FEMALE' [decreaseHeaderGap]="!unpaidUserChatBotExperiment" (redirectToTestimonialPage)="redirectToTestimonialsPage()"></testimonials-widget>
          </app-banner-wrapper>
        }

        @if (showExploreSliderBanner) {
          <app-banner-wrapper appTrackScrollDepth="explore_slider">
            <app-explore-slider-banner></app-explore-slider-banner>
          </app-banner-wrapper>
        }

        @if (homePageRehaulExperiment && showTreatmentPhilosophyWidget) {
          <app-banner-wrapper appTrackScrollDepth="treatment_philosophy">
            <app-treatment-philosophy-widget appTrackable pageName="homePage" bannerName='treatment_philosophy_widget' [user]="user"></app-treatment-philosophy-widget>
          </app-banner-wrapper>
        }
        <!-- week 0 to 1-->
        <!-- Old Week 0 -->
        @if (isJourneyCardOne && !weeklyJourneyV2Experiment) {
          <app-banner-wrapper appTrackScrollDepth="week_zero_journey">
            <div class="tw-relative weeklyCard tw-bg-teal-100" >
              <app-week-zero-journey
                appTrackable
                pageName="homePage"
                bannerName='week_zero_journey'
                [channels]="PRIMARY_CHANNELS"
                [user]="user"
                [latestPlacedRegimenOrder]="latestPlacedRegimenOrder"
                [userDrImage]="userDrImage"
                [allocatedDoctor]="allocatedDoctor"
                [defaultDoctorImage]="defaultDoctorImage"
                [primaryConcern]="primaryConcern"
                [otherConcerns]="otherConcerns"
                (trackOrder)="trackOrder($event)"
                (openInstructions)="openInstructions($event)"
                (openDiet)="openDiet()"
                (openHelp)="openHelp($event)"
                (sendClickEvent)="sendClickEventFromOldWeeklyJourney($event)"
              >
              </app-week-zero-journey>
            </div>
          </app-banner-wrapper>
        }
        <!-- New Week 0 -->
        @if (((isJourneyCardOne && weeklyJourneyV2Experiment) && (!weeklyJourneyVariant?.weekVisibility || isWeekVisible(WeeklyJourneyType.WEEK_ZERO)))) {
          <app-banner-wrapper appTrackScrollDepth="week_zero_journey">
            <app-weekly-journey
              appTrackable
              pageName="homePage"
              bannerName='week_zero_journey'
              [channels]="PRIMARY_CHANNELS"
              [journeyType]="WeeklyJourneyType.WEEK_ZERO"
              [journeyData]="getWeeklyJourneyData(WeeklyJourneyType.WEEK_ZERO)"
            ></app-weekly-journey>
          </app-banner-wrapper>
        }
        <!-- Old Week 1 part 1 -->
        @if (isWeekOne && userStatus.PAID && !weeklyJourneyV2Experiment) {
          <app-banner-wrapper appTrackScrollDepth="week_one_part_1_journey">
            <div class="tw-relative weeklyCard tw-bg-teal-100" >
              <app-week1-part-one
                appTrackable
                pageName="homePage"
                bannerName='week_one_part_1_journey'
                [channels]="PRIMARY_CHANNELS"
                [user]="user"
                [pendingCheckInCall]="pendingCheckInCall"
                [faceRegimenOrderDelivered]="faceRegimenOrderDelivered"
                [latestFaceRegimenDelivered]="latestFaceRegimenDelivered"
                (openInstructions)="openInstructions($event)"
                (openStaticArticle)='openStaticArticle("68tmQuvkpb",$event)'
                (openHelp)="openHelp($event)"
                (openCheckup)="openCheckup($event)"
                (sendClickEvent)="sendClickEventFromOldWeeklyJourney($event)"
              >
              </app-week1-part-one>
            </div>
          </app-banner-wrapper>
        }
        <!-- New Week 1 part 1 -->
        @if (((isWeekOne && userStatus.PAID && weeklyJourneyV2Experiment) && (!weeklyJourneyVariant?.weekVisibility || isWeekVisible(WeeklyJourneyType.WEEK_ONE_PART_ONE)))) {
          <app-banner-wrapper appTrackScrollDepth="week_one_part_1_journey">
            <app-weekly-journey
              appTrackable
              pageName="homePage"
              bannerName='week_one_part_1_journey'
              [channels]="PRIMARY_CHANNELS"
              [journeyType]="WeeklyJourneyType.WEEK_ONE_PART_ONE"
              [journeyData]="getWeeklyJourneyData(WeeklyJourneyType.WEEK_ONE_PART_ONE)"
              (openStaticArticle)='openStaticArticle("68tmQuvkpb",$event)'
            ></app-weekly-journey>
          </app-banner-wrapper>
        }
        <!-- Old Week 1 part 2 -->
        @if (isJourneyCardTwo && userStatus.PAID && !weeklyJourneyV2Experiment) {
          <app-banner-wrapper appTrackScrollDepth="week_one_part_2_journey">
            <div class="tw-relative weeklyCard tw-bg-teal-100" >
              <app-week1-part-two
                appTrackable
                pageName="homePage"
                bannerName='week_one_part_2_journey'
                [channels]="PRIMARY_CHANNELS"
                [user]="user"
                [pendingCheckInCall]="pendingCheckInCall"
                (openInstructions)="openInstructions($event)"
                (openStaticArticle1)='openStaticArticle("7T2BaIQHxh",$event)'
                (openStaticArticle2)='openStaticArticle("6dH4XFVff4",$event)'
                (sendClickEvent)="sendClickEventFromOldWeeklyJourney($event)"
              ></app-week1-part-two>
            </div>
          </app-banner-wrapper>
        }
        <!-- New Week 1 part 2 -->
        @if (((isJourneyCardTwo && userStatus.PAID && weeklyJourneyV2Experiment) && (!weeklyJourneyVariant?.weekVisibility || isWeekVisible(WeeklyJourneyType.WEEK_ONE_PART_TWO)))) {
          <app-banner-wrapper appTrackScrollDepth="week_one_part_2_journey">
            <app-weekly-journey
              appTrackable
              pageName="homePage"
              bannerName='week_one_part_2_journey'
              [channels]="PRIMARY_CHANNELS"
              [journeyType]="WeeklyJourneyType.WEEK_ONE_PART_TWO"
              [journeyData]="getWeeklyJourneyData(WeeklyJourneyType.WEEK_ONE_PART_TWO)"
            ></app-weekly-journey>
          </app-banner-wrapper>
        }

        <!-- week 2 -->
        <!-- Old Week 2 part 1 -->
        @if (isJourneyCardThree && userStatus.PAID && !weeklyJourneyV2Experiment) {
          <app-banner-wrapper appTrackScrollDepth="week_two_part_1_journey">
            <div class="tw-relative weeklyCard tw-bg-teal-100" >
              <app-week2-part-two
                appTrackable
                pageName="homePage"
                bannerName='week_two_part_1_journey'
                [channels]="PRIMARY_CHANNELS"
                [user]="user"
                [followUp]="followUp()"
                [userDrImage]="userDrImage"
                [defaultDoctorImage]="defaultDoctorImage"
                (openStaticArticle1)='openStaticArticle("BoXTnEmmEr",$event)'
                (openStaticArticle2)='openStaticArticle("68tmQuvkpb",$event)'
                (openCheckup)="openCheckup($event)"
                (sendClickEvent)="sendClickEventFromOldWeeklyJourney($event)"
              ></app-week2-part-two>
            </div>
          </app-banner-wrapper>
        }
        <!-- New Week 2 part 1 -->
        @if (((isJourneyCardThree && userStatus.PAID && weeklyJourneyV2Experiment) && (!weeklyJourneyVariant?.weekVisibility || isWeekVisible(WeeklyJourneyType.WEEK_TWO_PART_ONE)))) {
          <app-banner-wrapper appTrackScrollDepth="week_two_part_1_journey">
            <app-weekly-journey
              appTrackable
              pageName="homePage"
              bannerName='week_two_part_1_journey'
              [channels]="PRIMARY_CHANNELS"
              [journeyType]="WeeklyJourneyType.WEEK_TWO_PART_ONE"
              [journeyData]="getWeeklyJourneyData(WeeklyJourneyType.WEEK_TWO_PART_ONE)"
            ></app-weekly-journey>
          </app-banner-wrapper>
        }

        <!-- Old Week 2 part 2 -->
        @if (isJourneyCardFour && userStatus.PAID && !weeklyJourneyV2Experiment) {
          <app-banner-wrapper appTrackScrollDepth="week_two_part_2_journey">
            <div class="tw-relative weeklyCard tw-bg-teal-100" >
              <app-week2-part-one
                appTrackable
                pageName="homePage"
                bannerName='week_two_part_2_journey'
                [channels]="PRIMARY_CHANNELS"
                [user]="user"
                [followUp]="followUp()"
                (openInstructions)="openInstructions($event)"
                (openStaticArticle1)='openStaticArticle("hUUviTYk22",$event)'
                (openStaticArticle2)='openStaticArticle("7T2BaIQHxh",$event)'
                (sendClickEvent)="sendClickEventFromOldWeeklyJourney($event)"
              >

              </app-week2-part-one>
            </div>
          </app-banner-wrapper>
        }
        <!-- New Week 2 part 2 -->
        @if (((isJourneyCardFour && userStatus.PAID && weeklyJourneyV2Experiment) && (!weeklyJourneyVariant?.weekVisibility || isWeekVisible(WeeklyJourneyType.WEEK_TWO_PART_TWO)))) {
          <app-banner-wrapper appTrackScrollDepth="week_two_part_2_journey">
            <app-weekly-journey
              appTrackable
              pageName="homePage"
              bannerName='week_two_part_2_journey'
              [channels]="PRIMARY_CHANNELS"
              [journeyType]="WeeklyJourneyType.WEEK_TWO_PART_TWO"
              [journeyData]="getWeeklyJourneyData(WeeklyJourneyType.WEEK_TWO_PART_TWO)"
            ></app-weekly-journey>
          </app-banner-wrapper>
        }

        <!-- week 3 -->
        <!-- Old Week 3 -->
        @if (isWeekThreeJourneyCard && userStatus.PAID && !weeklyJourneyV2Experiment) {
          <app-banner-wrapper appTrackScrollDepth="week_three_journey">
            <div class="tw-relative weeklyCard tw-bg-teal-100" >
              <app-week3-part-one
                appTrackable
                pageName="homePage"
                bannerName='week_three_journey'
                [channels]="PRIMARY_CHANNELS"
                [user]="user"
                [followUp]="followUp()"
                (sendClickEvent)="sendClickEventFromOldWeeklyJourney($event)"
              ></app-week3-part-one>
            </div>
          </app-banner-wrapper>
        }
        <!-- New Week 3 -->
        @if (((isWeekThreeJourneyCard && userStatus.PAID && weeklyJourneyV2Experiment) && (!weeklyJourneyVariant?.weekVisibility || isWeekVisible(WeeklyJourneyType.WEEK_THREE)))) {
          <app-banner-wrapper appTrackScrollDepth="week_three_journey">
            <app-weekly-journey
              appTrackable
              pageName="homePage"
              bannerName='week_three_journey'
              [channels]="PRIMARY_CHANNELS"
              [journeyType]="WeeklyJourneyType.WEEK_THREE"
              [journeyData]="getWeeklyJourneyData(WeeklyJourneyType.WEEK_THREE)"
            ></app-weekly-journey>
          </app-banner-wrapper>
        }

        <!-- week 4 -->
        <!-- Old Week 4 -->
        @if (isWeekFourJourneyCard && userStatus.PAID && !weeklyJourneyV2Experiment) {
          <app-banner-wrapper appTrackScrollDepth="week_four_journey">
            <div class="tw-relative weeklyCard tw-bg-teal-100" >
              <app-week4-part-one
                appTrackable
                pageName="homePage"
                bannerName='week_four_journey'
                [channels]="PRIMARY_CHANNELS"
                [user]="user"
                [followUp]="followUp()"
                (sendClickEvent)="sendClickEventFromOldWeeklyJourney($event)"
              ></app-week4-part-one>
            </div>
          </app-banner-wrapper>
        }
        <!-- New Week 4 -->
        @if (((isWeekFourJourneyCard && userStatus.PAID && weeklyJourneyV2Experiment) && (!weeklyJourneyVariant?.weekVisibility || isWeekVisible(WeeklyJourneyType.WEEK_FOUR)))) {
          <app-banner-wrapper appTrackScrollDepth="week_four_journey">
            <app-weekly-journey
              appTrackable
              pageName="homePage"
              bannerName='week_four_journey'
              [channels]="PRIMARY_CHANNELS"
              [journeyType]="WeeklyJourneyType.WEEK_FOUR"
              [journeyData]="getWeeklyJourneyData(WeeklyJourneyType.WEEK_FOUR)"
            ></app-weekly-journey>
          </app-banner-wrapper>
        }

        <!--redirect to new shop banner-->
        @if (shouldShowShopNavigateBanner) {
          <app-banner-wrapper appTrackScrollDepth="shop_banner">
            <shop-navigate-banner appTrackable pageName="homePage" bannerName='shop_banner'></shop-navigate-banner>
          </app-banner-wrapper>
        }

        @if (showDietBannerCollapsed) {
          <ng-container [ngTemplateOutlet]="dietBannerTpl"></ng-container>
        }

        <!--Analysis of the day-->
        @if (showAnalysisBannerBottom) {
          <app-banner-wrapper appTrackScrollDepth="instant_checkup">
            <app-analysis-banner appTrackable pageName="homePage" bannerName='instant_checkup' [channels]="PRIMARY_CHANNELS" (analysisOfTheDay)="analysisOfTheDay()"></app-analysis-banner>
          </app-banner-wrapper>
        }
        <!--New game-->
        @if (isPaidUser) {
          @if (isRetentionHomeRevampActive) {
            <app-banner-wrapper appTrackScrollDepth="quiz">
              <quiz-banner-v2 (openGame)="openGame($event)" [userLanguagePreference]="user.get('languagePreference')"></quiz-banner-v2>
            </app-banner-wrapper>
          } @else {
            <app-banner-wrapper appTrackScrollDepth="quiz">
              <app-quiz-banner appTrackable pageName="homePage" bannerName='quiz' [userStatus]="userStatus" [showGameBanner]="showGameBanner" (openGame)="openGame()"></app-quiz-banner>
            </app-banner-wrapper>
          }
        }

        @if (showCrossRegimenBannerBottom) {
          <app-banner-wrapper [appTrackScrollDepth]="crossSellScrollBannerName">
            <cross-regimen-banner-v2
              appTrackable pageName="homePage"
              [bannerName]="crossSellScrollBannerName"
              [latestActiveRegimen]="latestActiveRegimen"
              [user]="user"
            ></cross-regimen-banner-v2>
          </app-banner-wrapper>
        }

        <!-- Add this where you want the carousel to appear -->
        @if (showLastLevelBanner) {
          <div appTrackable pageName="homePage" appTrackScrollDepth="last_levels" [bannerName]="'last_levels'" class="tw-pb-4 tw-px-4 tw-relative">
            <swiper  [config]="customCarouselConfig" class="tw-w-full tw-rounded-xl tw-overflow-hidden tw-my-medium">
              <!-- Render banners according to lastLevelBannerOrder -->
              @for (bannerType of lastLevelBannerOrder; track bannerType) {
                <!-- Diet banner -->
                @if (bannerType === 'DIET' && !(isRetentionHomeRevampExperimentEnabled && dietBannerRegimen)) {
                  <div *swiperSlide class="tw-w-full" (click)="openDiet('lastLevelDietBanner')">
                    <last-level-banner type="DIET" [user]="user"></last-level-banner>
                  </div>
                }

                <!-- Refer banner -->
                @if (bannerType === 'REFER') {
                  <div *swiperSlide class="tw-w-full" (click)="referBannerClick()">
                    <last-level-banner type="REFER" [user]="user"></last-level-banner>
                  </div>
                }
              }
            </swiper>

            <!-- Custom pagination -->
            <div class="custom-pagination"></div>
          </div>
        }
        <!--    notification banner   -->
        @if (showNotificationBanner) {
          <app-banner-wrapper appTrackScrollDepth="enable_notifications">
            <notification-permission-banner
              appTrackable pageName="homePage"
              bannerName='enable_notfications'
              (close)="respondPermissionBanner(false)"
              (enable)="respondPermissionBanner(true)">
            </notification-permission-banner>
          </app-banner-wrapper>
        }
        @if (showBentoGrid) {
          <app-banner-wrapper appTrackScrollDepth="bento_grid_bottom">
            <div class="tw-bg-white tw-pt-5 tw-pb-1">
              <app-bento-grid appTrackable pageName="homePage" bannerName='bento_grid_bottom' [channels]="PRIMARY_CHANNELS" [columns]="2" [gap]="2" [padding]="4" ariaLabel="Treatment information and navigation">
                @for (card of bentoGridCards; track card.type) {
                  <app-action-with-image-banner
                    bentoGridItem
                    [bentoGridItemSpan]="card.colSpan"
                    bentoGridItemAriaLabel="{{ card.bannerText }}"
                    [imageUrl]="card.imageUrl"
                    [bannerText]="card.bannerText"
                    [bannerSubText]="card.bannerSubText"
                    [navigationLink]="card.navigationLink"
                    [customStyling]="card.customStyling"
                    [isRebranded]="isRetentionHomeRevampExperimentEnabled"
                  >
                  </app-action-with-image-banner>
                }
              </app-bento-grid>
            </div>
          </app-banner-wrapper>
        }
        @if (isRetentionHomeRevampActive) {
          <app-banner-wrapper appTrackScrollDepth="more_for_you">
            <more-for-you appTrackable pageName="homePage" bannerName="more_for_you"></more-for-you>
          </app-banner-wrapper>
        }
        <!--FAQ section-->
        <app-banner-wrapper appTrackScrollDepth="faq_section">
          <app-faq-section></app-faq-section>
        </app-banner-wrapper>
        <!--Contact us-->
        @if (shouldShowExploreContactBanner) {
          <app-banner-wrapper appTrackScrollDepth="explore_contact">
            <app-explore-contact-banners [userStatus]="userStatus" [user]="user" [hideExplorePanel]="showExploreSliderBanner" [showExploreSection]="showExploreSection" (optedForSupport)="optedForSupport($event)" (exploreSectionRedirect)="exploreSectionRedirect()"></app-explore-contact-banners>
          </app-banner-wrapper>
        }
      </div>
    }
  </div>
</div>
<!--sticky bar for discomfort ticket-->
@if (!homePageFullScreenModeOn) {
  <discomfort-ticket [ngClass]="{'tw-hidden': isMenuOpen }" appTrackable pageName="homePage" [pendingTicket]="pendingDiscomfortTicket" [userName]="userName" [user]="user" [audioMessageInTicket]="audioMessageInTicket" [activeDiscomfortTicket]="activeDiscomfortTicket" [defaultDoctorImage]="defaultDoctorImage" [userDoctor]="allocatedDoctor" (trackVoiceEvent)="trackVoiceEventDiscomfortTicket($event)" [showDiscomfortBanner]="showDiscomfortBanner"></discomfort-ticket>
}

<!--sticky bar for cart items-->
@if (shouldShowStickyWidget && !audioMessageInTicket && !pendingDiscomfortTicket && !homePageFullScreenModeOn) {
  <app-sticky-bar  [showStickyBars$]="showStickyBars$" [userStatus]="userStatus" [bannerContainer]="bannerContainer" [order]="order" [followUp]="followUp()" [allocatedDoctor]="followUpDoctor" [defaultDoctorImage]="defaultDoctorImage" [toolbarIcons]="toolbarIcons" [user]="user" (onSlideChange)="onSlideChange($event)" (checkoutOrder)="checkoutOrder()" (onCancelClick)="onCancelClick()" (startFollowUp)="startFollowUp()" (kitUrl)="getKitImage()" (goToCartNav)="goToCartNav()"></app-sticky-bar>
}

<div class="navigation-drawer">
  <!-- <div class="drawer-bg" (click)="toggleMenu(false)" [ngClass]="{ 'open': isMenuOpen, 'close': !isMenuOpen, 'hide': isMenuOpen === undefined }"></div> -->
  <div class="drawer-content trans-x-hide" swipe="swipe" (coordinates)="swipeCoordinates($event)" [ngClass]='{ "slideFromLeft": isMenuOpen, "slideToLeft": isMenuOpen === false }' (click)="toggleMenu(false)">
    <div class="holder w100">
      @if (!loading) {
        <user-profile (onPopupToggle)="makeComponentActive(!$event)" [regimens]="regimens"></user-profile>
      }
    </div>
  </div>
</div>
